import Vue from 'vue'

export default class Sitewide {
    constructor(ctx, args) {
        this.ctx = ctx

        this.fontFamily = 'PlatformFont'
        this.fontWeights = {
            normal: 400,
            bold: 700,
            extrabold: 900,
        }

        const initialState = typeof args === 'string' ? JSON.parse(args) : args
        const {
            isNavbarPreview = false,
            sitewideBanner = null,
            navbar = null,
            styles = null,
            seo = null,
        } = initialState

        this.state = Vue.observable({
            isNavbarPreview,
            sitewideBanner,
            navbar,
            styles,
            seo,
        })
    }

    get navbar() {
        return this.state.navbar
    }

    get sitewideBanner() {
        return this.state.sitewideBanner
    }

    get styles() {
        return this.state.styles
    }

    get seo() {
        return this.state.seo
    }

    get css() {
        const cssVariables = [
            `--fontFamily: '${this.fontFamily}';`,
            `--fontWeightNormal: ${this.fontWeights.normal};`,
            `--fontWeightBold: ${this.fontWeights.bold};`,
            `--fontWeightExtrabold: ${this.fontWeights.extrabold};`,
        ]

        const cssFontFaces = []

        Object.entries(this.state.styles.content).forEach(([key, value]) => {
            if (key.startsWith('color')) {
                cssVariables.push(`--${key}: ${value.color};`)
            } else if (key.startsWith('fontSize')) {
                cssVariables.push(`--${key}: ${value}px;`)
            } else if (key.startsWith('fontFile')) {
                // Get the font weight from the key i.e. fontFileNormal => normal
                const weight = key.split('fontFile').pop().toLowerCase()
                cssFontFaces.push(
                    '@font-face{',
                    `font-family: '${this.fontFamily}';`,
                    'font-style: normal;',
                    'font-display: fallback;',
                    `font-weight: ${this.fontWeights[weight]};`,
                    `src: url('${this.ctx.$storyblok.formatSrc(value.filename)}') format('woff2');`,
                    '}'
                )
            }
        })

        return [
            ...cssFontFaces,
            `:root {${cssVariables.join('')}}`,
            this.state.styles.content.css,
        ].join('')
    }

    get fontPreloads() {
        return Object.entries(this.state.styles.content).reduce((acc, [key, value]) => {
            if (key.startsWith('fontFile')) {
                acc.push({
                    rel: 'preload',
                    as: 'font',
                    href: this.ctx.$storyblok.formatSrc(value.filename),
                    type: 'font/woff2',
                    crossorigin: '',
                    once: true,
                })
            }
            return acc
        }, [])
    }

    get isNavbarPreview() {
        return this.state.isNavbarPreview
    }

    setNavbarStory(navbarStory) {
        this.state.navbar = navbarStory
    }

    setPreviewNavbar(navbarStory) {
        this.state.isNavbarPreview = true
        this.state.navbar = navbarStory
    }

    setStyles(styles) {
        this.state.styles = styles
    }

    serialize() {
        return JSON.stringify(this.state)
    }

    getBaseMetaTemplates(prefix) {
        if (!this.seo) return null

        const template = {}
        const templateIndex = this.seo.content
        const templateKeys = [
            'description',
            'descriptionMake',
            'descriptionModel',
            'descriptionYear',
            'title',
            'titleFitment',
        ]

        templateKeys.forEach((key) => {
            const typeKey = `${prefix}${key[0].toUpperCase()}${key.substring(1)}` // description -> brandDescription
            if (templateIndex[typeKey]) template[key] = templateIndex[typeKey]
        })

        // was there anything actually filled out?
        if (Object.keys(template).length > 0) return template
        return null
    }
}
